import {camelcaseToHyphen} from "../../utils/linktools";

function getTagName(tag) {
	let result = null;
	const regExp = /vue-component-\w*-(.*)$/;
	if(regExp.test(tag)){
		result = RegExp.$1;
		result = camelcaseToHyphen(result);
	}
	return result;
}

function getNodeCol(t) {
	let col = String(t.data && t.data.attrs && t.data.attrs.col) - 0;
	return isNaN(col) ? 1: col;
}
function isWhiteSpace(node) {
	return (node.isComment && !node.asyncFactory) || node.text === ' '
}

const TARGET = 'el-form-item';

function isTarget(node) {
	let flag = false;
	if(node.componentOptions && getTagName(node.tag)===TARGET){
		flag = true;
	}else if(node.data && node.data){
		const className = [node.data.class || '', node.data.staticClass].join(' ');
		flag = className.split(' ').indexOf(TARGET) > -1;
	}
	if(flag && getNodeCol(node)<0){
		flag = false;
	}
	return flag;
}

function addGridRender(vnode, renderFunc) {
	let children = Array.isArray(vnode) ? vnode : vnode.children;
	if(vnode.componentOptions){
		if(getTagName(vnode.tag) === 'my-row') return;
		children =  vnode.componentOptions.children;
	}
	if(!(children || []).length) return;

	const nodes = [...children];
	let node;
	const groups = [];

	/*按节点是否连续进行分组*/
	do {
		node = nodes.shift();
		if(!isTarget(node)){
			addGridRender(node, renderFunc);
			continue;
		}
		const team = [];
		do {
			team.push(node);
			node = nodes.shift();
		}while (node && (isWhiteSpace(node) || isTarget(node)));
		groups.push(team);
	}while (nodes.length);

	/*安装栅格渲染函数*/
	groups.forEach((team)=> renderFunc(team, children));
}

const MyRow = {
	props: {ctx: Object},
	render(){
		return (<el-row class="form-grid-row">{this.$slots.default}</el-row>);
	}
}

const MyCol = {
	provide(){
		return {myCol: this};
	},
	props: {
		option: Object,
		col: [Number, String]
	},
	computed: {
		maxCols(){
			const maxCols = String((this.option || {}).gridCols) - 0;
			return isNaN(maxCols) ? 0 : Math.min(maxCols, 24);
		},
		baseSpan(){
			const baseSpan = Math.floor(24 / this.maxCols);
			return Math.max(1, isNaN(baseSpan) ? 24 : baseSpan);
		},
		cellCols(){
			const col = String(this.col) - 0;
			return isNaN(col) ? 1 : Math.min(col, this.maxCols)
		}
	},
	render(){
		return (<el-col class={`formcell-col-${this.cellCols}`} span={this.cellCols * this.baseSpan}>{this.$slots.default}</el-col>);
	}
}

export default {
	props: {
		option: Object
	},
	components: {MyRow,MyCol},
	data(){
		return {
			/*目标实例的上下文集合*/
			itemCtxs: {}
		}
	},
	methods: {
		gridRender(team, nodes){
			const i = team[0];
			this.itemCtxs[i.context._uid] = i.context;
			const index = nodes.indexOf(i);
			const target = (
				<my-row ctx={this}>{team.map((t)=> {
					nodes.splice(index, 1);
					if(isWhiteSpace(t)){
						return t;
					}
					const col = getNodeCol(t);
					return <my-col option={this.myOption} col={col}>{t}</my-col>
				})}
				</my-row>
			);
			nodes.splice(index, 0, target);
		},
		_patch_grid(v){
			addGridRender(v, this.gridRender);
			return v;
		}
	}
}

